import { cn } from "@/lib/utils";

/** StockSync mark — two offset stacked layers suggesting synced inventory. */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      className={cn("size-7", className)}
      aria-hidden="true"
    >
      <rect width="32" height="32" rx="8" className="fill-primary" />
      <path
        d="M9 12.5 16 9l7 3.5-7 3.5-7-3.5Z"
        className="fill-primary-foreground"
        opacity="0.95"
      />
      <path
        d="M9 16.5 16 20l7-3.5"
        className="stroke-primary-foreground"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.55"
      />
      <path
        d="M9 20.5 16 24l7-3.5"
        className="stroke-primary-foreground"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.3"
      />
    </svg>
  );
}

export function Wordmark({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <LogoMark />
      <span className="text-lg font-bold tracking-tight text-foreground">
        Stock<span className="text-primary">Sync</span>
      </span>
    </div>
  );
}
